import { createForm } from '@codeleap/common'

export const reportFeedItem = () =>
  createForm('reportFeedItem', {
    reason: {
      type: 'select',
      label: 'Select a reason'
    }
  })
